{
    "Profile_Renewal_Action.autoInsurance": "auto Insurance",
    "Profile_Renewal_Action.fluxCommautoInsurance": "flux-commauto Insurance",
    "Profile_Renewal_Action.bundleInsurance": "bundle Insurance",
    "Profile_Renewal_Action.condoInsurance": "condo Insurance",
    "Profile_Renewal_Action.homeInsurance": "home Insurance",
    "Profile_Renewal_Action.landlordInsurance": "landlord Insurance",
    "Profile_Renewal_Action.motorcycleInsurance": "motorcycle Insurance",
    "Profile_Renewal_Action.roomateInsurance": "roomate Insurance",
    "Profile_Renewal_Action.tenantInsurance": "tenant Insurance",
    "Profile_Renewal_Action.rvInsurance": "rv Insurance",
    "Profile_Renewal_Action.pleasurecraftInsurance": "pleasurecraft Insurance",
    "Profile_Renewal_Action.name": "Name",
    "Profile_Renewal_Action.address": "Address",
    "Profile_Renewal_Action.contact": "Contact",
    "Profile_Renewal_Action.viewPriorPolicy": "View Prior Policy"
}
